module.exports = __webpack_public_path__ + "static/media/brushStroke_4.912f246d.png";